// First question

$("#q1-1").click(function(){
  // At Work -- Collection
  //$("#q1").hide();
  //$('#q2-1').removeAttr('hidden');
  window.location.href = "https://alpacasofmontana.com/collections/at-work";
})

$("#q1-2").click(function(){
  // While Working Out -- List
  $("#q1").hide();
  $('#q2-2').removeAttr('hidden');
})

$("#q1-3").click(function(){
  // Hunting/Fishing Collection
  //$("#q1").hide();
  //$('#q2-1').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-hunting-fishing";
})

$("#q1-4").click(function(){
  // At Home -- collection
  //$("#q1").hide();
  //$('#q2-3').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-at-home"
})

$("#q1-5").click(function(){
  // To Go Out -- Colleciton
  //$("#q1").hide();
  //$('#q2-5').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-to-go-out"
})

$("#q1-6").click(function(){
  // While Working Outside -- new list
  $("#q1").hide();
  $('#q2-6').removeAttr('hidden');
})

$("#q1-7").click(function(){
  // During the Winter -- Collection
  //$("#q1").hide();
  //$('#q2-6').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-during-the-winter-i-want-your-warmest-sock"
})

$("#q1-8").click(function(){
  // For All Four Seasons -- Collection
  //$("#q1").hide();
  //$('#q2-7').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-for-all-four-seasons-i-want-versatility"
})


// Second question specifically for "While working out"

$("#q2-2-1").click(function(){
  // Running -- Collection
  //$("#q2-2").hide();
  //$('#q3-1').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-out-running";
})

$("#q2-2-2").click(function(){
  // Hiking/Walking -- Collection
  //$("#q2-2").hide();
  //$('#q3-2').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-out-hiking-walking";
})

$("#q2-2-3").click(function(){
  // Snowsports -- new list
  $("#q2-2").hide();
  $('#q3-3').removeAttr('hidden');
  //window.location.href=""
})

$("#q2-2-4").click(function(){
  // At the Gym -- Collection
  //$("#q2-2").hide();
  //$('#q3-4').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-out-at-the-gym"
})

$("#q2-2-5").click(function(){
  // Biking -- Collection
  //$("#q2-2").hide();
  //$('#q3-5').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-out-biking"
})

// Third question "While Working out -> Snowsports"

$("#q3-3-1").click(function(){
  // Alpine or Backcountry Skiing/Snowboarding -- Collection
  //$("#q3-3").hide();
  //$('#q4-1').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-out-snowsports-alpine-or-backcountry-skiing-snowboarding"
})

$("#q3-3-2").click(function(){
  // Cross Country Skking -- Collection
  //$("#q3-3").hide();
  //$('#q4-2').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-out-snowsports-cross-country-skiing"
})

$("#q3-3-3").click(function(){
  // Snowshoeing -- Collection
  //$("#q3-3").hide();
  //$('#q4-3').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-out-snowsports-snowshoeing"
})

// Second question "While working outside"

$("#q2-6-1").click(function(){
  // Warmth -- Collection
  //$("#q2-6").hide();
  //$('#q5-1').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-outside-warmth"
})

$("#q2-6-2").click(function(){
  // Mid Weight Technical -- Collection
  //$("#q2-6").hide();
  //$('#q5-2').removeAttr('hidden');
  window.location.href="https://alpacasofmontana.com/collections/sock-finder-while-working-outside-mid-weight-technical"
})
